import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getEnv } from '../../lib/env';

import useDarkMode from '../../hooks/useDarkMode';

import { LifebuoyColorIcon, LifebuoyColorIconWhite } from '../../images/shapes';

import { useSupportIssues } from '../SupportIssueModal/useSupportIssues';

export const useHelpCenterMenuItems = () => {
  const { t } = useTranslation();
  const [darkMode] = useDarkMode();
  const { handleSupportIssues } = useSupportIssues();

  const helpCenterContent = useMemo(() => {
    const links = [];

    if (getEnv('VITE_DOCUMENTATION')) {
      links.push({
        title: t('HelpCenter.Documentation'),
        link: getEnv('VITE_DOCUMENTATION'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Documentation',
        hidePin: true,
      });
    }

    if (getEnv('VITE_DISCORD')) {
      links.push({
        title: t('HelpCenter.Support'),
        link: getEnv('VITE_DISCORD'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Support',
        hidePin: true,
      });
    }

    if (getEnv('VITE_DEMO')) {
      links.push({
        title: t('HelpCenter.Demo'),
        link: getEnv('VITE_DEMO'),
        target: '_blank',
        rel: 'noreferrer',
        key: 'Demo',
        hidePin: true,
      });
    }

    if (getEnv('VITE_SUPPORT_ISSUES_ENABLED') === 'true') {
      links.push({
        title: t('SupportIssueModal.Label'),
        onClick: handleSupportIssues,
        key: 'supportIssues',
        hidePin: true,
      });
    }
    return links;
  }, [t, handleSupportIssues]);

  const helpCenterMenuItems = useMemo(
    () =>
      helpCenterContent.length > 0
        ? [
            {
              key: 'help-center',
              icon: darkMode ? (
                <LifebuoyColorIconWhite className="w-5 min-w-5 ml-0.5" />
              ) : (
                <LifebuoyColorIcon className="w-5 min-w-5 ml-0.5" />
              ),
              title: t('Global.HelpCenter'),
              children: helpCenterContent,
              hidePin: true,
            },
          ]
        : [],
    [helpCenterContent, darkMode, t],
  );

  return { helpCenterMenuItems };
};
